/* eslint-disable @typescript-eslint/no-unsafe-call */
// @ts-nocheck
import { logError } from 'src/shared/telemetry/logger';

import { isIframeFullscreen } from './isIframeFullscreen';

const requestFullscreen = () => {
  if (document.documentElement?.requestFullscreen) {
    void document.documentElement?.requestFullscreen();
  } else if (document.documentElement?.mozRequestFullScreen) {
    document.documentElement?.mozRequestFullScreen();
  } else if (document.documentElement?.webkitRequestFullscreen) {
    document.documentElement?.webkitRequestFullscreen(
      Element.ALLOW_KEYBOARD_INPUT,
    );
  }
};

const cancelFullscreen = () => {
  if (document?.cancelFullScreen) {
    document.cancelFullScreen();
  } else if (document?.mozCancelFullScreen) {
    document?.mozCancelFullScreen();
  } else if (document?.webkitCancelFullScreen) {
    document?.webkitCancelFullScreen();
  }
};

const toggleFullscreen = () => {
  try {
    if (isIframeFullscreen()) {
      cancelFullscreen();
    } else {
      requestFullscreen();
    }
  } catch (error) {
    logError(error as Error);
  }
};

export { toggleFullscreen, requestFullscreen, cancelFullscreen };
